(function () {
'use strict';

angular.module('hyresgastApp').controller('ErrorModalCtrl', ErrorModalCtrl);

function ErrorModalCtrl($uibModalInstance, RentFiles, NegotiationCall, HyUtils, validationResponse, realEstateChoiceMethod) {
  var vm = this;
  vm.status = validationResponse;
  vm.showDetailedInfo = vm.status.total ? vm.status.total > 5000 : false;

  vm.hasCommonFailure = vm.status.failedPhase ? true : false;
  vm.missingMandatoryColumns = !vm.hasCommonFailure && vm.status.missingMandatoryColumns && vm.status.missingMandatoryColumns.length > 0;
  vm.wrongApartments = !vm.hasCommonFailure && !vm.missingMandatoryColumns && (vm.status.summary.numApartments === null || vm.status.summary.numApartments === 0);

  vm.showDownloadReport = vm.status.missingMandatoryColumns ? vm.status.missingMandatoryColumns.length === 0 : (!vm.hasCommonFailure && !vm.wrongApartments);

  let sources = 0;
  let errorTypeNames = [
    "failedRows",
    "duplicates",
    "nulls",
    "missingApartmentsFromAgreement",
    "misspelledMunicipalities",
    "misspelledPropertyDesignations",
    "notExistingApartments",
    "misspelledAddresses",
    "alreadyAssigned",
  ];

  for (let i = 0; i < errorTypeNames.length; i++) {
    if (vm.status[errorTypeNames[i]] && vm.status[errorTypeNames[i]].length > 0) {
      sources++;
    }
  }

  vm.hasMultipleErrors = !vm.hasCommonFailure && !vm.missingMandatoryColumns && !vm.wrongApartments && sources > 1;
  let convert = (name) => { return "has" + name.charAt(0).toUpperCase() + name.slice(1); };
  for (let i = 0; i < errorTypeNames.length; i++) {
    vm[convert(errorTypeNames[i])] = sources === 1 && vm.status[errorTypeNames[i]] && vm.status[errorTypeNames[i]].length > 0;
  }

  vm.cancel = cancel;

  vm.validationExcelId = validationResponse.blobId;

  vm.downloadErrorReport = () => {
    if (realEstateChoiceMethod === 'RENT_LIST') {
      NegotiationCall.getRentListErrorReport({
        blobId: vm.validationExcelId,
      }).$promise.then(response => {
        HyUtils.spitOutAttachment(response.data, 'error_report.xlsx', 'application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet');
      });
    } else if (realEstateChoiceMethod === 'PROPERTY_LIST') {
      NegotiationCall.getPropertyListErrorReport({
        blobId: vm.validationExcelId,
      }).$promise.then(response => {
        HyUtils.spitOutAttachment(response.data, 'error_report.xlsx', 'application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet');
      });
    } else {
      RentFiles.getErrorReport({
        blobId: vm.validationExcelId,
      }).$promise.then(response => {
        HyUtils.spitOutAttachment(response.data, 'error_report.xlsx', 'application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet');
      });
    }
  };

  function cancel() {
    $uibModalInstance.dismiss();
  }
}

})();